import React from 'react'
import UserPageSection from '../sections/UserPageSection/Content'
const UserPage = () => {
  return (
 <UserPageSection/>
  )
}

export default UserPage;
